const css = `._topper_1gx2j_1 h1 {
  text-align: center;
}
._topperDateTimeTags_1gx2j_4 {
  display: flex;
  font-family: var(--font-date-and-tags);
  font-size: 0.8em;
  gap: 32px;
  justify-content: space-between;
}
._topperDateTimeTags_1gx2j_4:empty {
  display: none;
}
._topperDateTime_1gx2j_4 {
  color: var(--secondary-text-color);
  text-align: right;
  white-space: nowrap;
}
._topperDescription_1gx2j_19 {
  color: var(--secondary-text-color);
  font-family: var(--font-description);
  text-align: center;
}
._topper_1gx2j_1[data-topper-type=cascade] {
  margin: auto;
  width: 100%;
  max-width: 576px;
}
._topper_1gx2j_1[data-topper-type=cascade] img,
._topper_1gx2j_1[data-topper-type=cascade] svg {
  height: auto;
  margin: auto;
  max-width: 100%;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "topper": "_topper_1gx2j_1",
  "topperDateTimeTags": "_topperDateTimeTags_1gx2j_4",
  "topperDateTime": "_topperDateTime_1gx2j_4",
  "topperDescription": "_topperDescription_1gx2j_19"
};